import { environment } from '@environments/environment';

export function LogLifecycle() {
  return function (constructor: any): void {
    if (environment.production) return;

    const originalOnInit = constructor.prototype.ngOnInit;
    const originalOnDestroy = constructor.prototype.ngOnDestroy;

    constructor.prototype.ngOnInit = function (): void {
      console.log('\x1b[34m' + '[OnInit] > ' + constructor.name + '\x1b[0m');

      if (originalOnInit && typeof window !== 'undefined') {
        originalOnInit.apply(this);
      }
    };

    constructor.prototype.ngOnDestroy = function (): void {
      console.log('\x1b[34m' + '[OnDestroy] < ' + constructor.name + '\x1b[0m');

      if (originalOnDestroy && typeof window !== 'undefined') {
        originalOnDestroy.apply(this);
      }
    };
  };
}
